import React from 'react';  
import { motion } from 'framer-motion';  
import { List, Clock } from 'lucide-react';  
  
const Historial = ({ historial, onLimpiarHistorial }) => {  
  if (!historial || historial.length === 0) {  
    return (  
      <motion.div  
        className="bg-white/80 backdrop-blur-xl rounded-2xl p-6 text-center shadow-lg"  
        initial={{ opacity: 0, y: 20 }}  
        animate={{ opacity: 1, y: 0 }}  
      >  
        <Clock className="w-12 h-12 text-gray-400 mx-auto mb-4" />  
        <p className="text-gray-600 font-medium">No hay historial aún. ¡Juega para empezar!</p>  
      </motion.div>  
    );  
  }  
  
  return (  
    <div className="bg-white/80 backdrop-blur-xl rounded-2xl p-6 shadow-lg">  
      <div className="flex items-center gap-3 mb-4">  
        <List className="w-6 h-6 text-blue-600" />  
        <h3 className="font-bold text-lg">Historial de Cartas</h3>  
      </div>  
      <div className="space-y-2 max-h-48 overflow-y-auto">  
        {historial.map((carta, index) => (  
          <motion.div  
            key={carta.id}  
            className="flex justify-between items-center p-3 bg-gray-50 rounded-lg"  
            initial={{ opacity: 0, x: -20 }}  
            animate={{ opacity: 1, x: 0 }}  
            transition={{ delay: index * 0.05 }}  
          >  
            <span className="font-medium">#{carta.id} - {carta.descripcion}</span>  
            <span className="text-xs text-gray-500">Pos: {index + 1}</span>  
          </motion.div>  
        ))}  
      </div>  
      <button  
        onClick={onLimpiarHistorial}  
        className="mt-4 px-4 py-2 bg-red-500 hover:bg-red-600 text-white rounded-lg font-medium transition-colors"  
      >  
        Limpiar Historial  
      </button>  
    </div>  
  );  
};  
  
export default Historial;